import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { NormalizedCategory } from "~/types/search.types";
import { Language } from "~/providers/LanguageProvider";

interface ICategoryItem {
    category: NormalizedCategory;
    isActive: boolean;
    isFetching: boolean;
    btnClickCallback: (item: NormalizedCategory) => void;
}

const CategoryItem = (props: ICategoryItem) => {
    const { category, isActive, isFetching, btnClickCallback } = props;
    const { i18n } = useTranslation();
    const language = i18n.language as Language;

    const categoriesCount = category.selectedTopicIds?.length || 0;
    const categoryName = category?.label[language];

    const btnClass = clsx(
        "flex justify-between items-center h-9 p-2 rounded-1 text-sm text-stone-darkest text-left font-medium-light tracking-[-0.28px] rounded hover:bg-stone-lighter",
        isActive && "bg-stone-lighter !font-bold"
    );

    return (
        <button
            className={btnClass}
            onClick={() => btnClickCallback(category)}
            disabled={isFetching}
        >
            <div>{categoryName}</div>

            {categoriesCount > 0 &&
                <div className="w-5 h-5 text-xs text-stone-lightest text-center !font-normal leading-[18px] tracking-[-0.24px] rounded-[37.5rem] bg-salmon-primary">
                    {categoriesCount}
                </div>
            }
        </button>
    );
}

export default CategoryItem;
